// extracted by mini-css-extract-plugin
export var highlightFade = "_3g-4";
export var highlighted = "_3g-3";
export var table = "_3g-1";
export var tableContainer = "_3g-0";
export var totalsRow = "_3g-2";